export default __webpack_public_path__ + "static/media/Q2.6aa5234a.jpg";